export default "__VITE_ASSET__DLHINmAe__"